<template>
    <div class="container-fluid">
        <div class="row" style="padding:10px 0 10px 60px;background-color:white;">
            <div class="col-6">
                <img src="../../../public/img/logo-hki.png" width="100px" height="50px" style="float:left;padding-right:10px;" />
                <span style="display:block; margin-top:15px;">Direktorat Jenderal Kekayaan Intelektual</span>
            </div>
        </div>
        <template v-if="fpdata.NOMORID != undefined">
        <div class="row" style="padding:30px 0 0 60px;font-size:18px;">
            <div class="col-12">
                    <table>
                        <tr>
                            <td colspan="4" style="padding:0 0 20px 0;">
                                Direktorat Jenderal Kekayaan Intelektual, Kementerian Hukum dan Hak Asasi Manusia Republik Indonesia menyatakan bahwa:
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align:right">I.</td>
                            <td style="width:35%;padding-left:5px;">Nomor permohonan</td>
                            <td>:</td>
                            <td style="padding-left:10px;">{{ fpdata.NOMORID }}</td>
                        </tr>
                        <tr>
                            <td style="text-align:right">II.</td>
                            <td style="padding-left:5px;">Nomor Desain Industri</td>
                            <td>:</td>
                            <td style="padding-left:10px;">{{ fpdata.REGISTRATION }}</td>
                        </tr>

                        <tr>
                            <td style="text-align:right">III.</td>
                            <td style="padding-left:5px;">Tanggal Penerimaan</td>
                            <td>:</td>
                            <td style="padding-left:10px;">{{ fpdata.TGLPENERIMAAN }}</td>
                        </tr>
                        <tr>
                            <td style="text-align:right">IV.</td>
                            <td style="padding-left:5px;">Pendesain</td>
                            <td>:</td>
                            <td style="padding-left:10px;">
                                <span style="display:block;" v-for="pinv in fpdata.INVENTORS" v-bind:key="pinv.NAME">
                                    {{ pinv.NAME }}
                                </span>
                            </td>

                        </tr>
                        <tr>
                            <td rowspan="4" style="vertical-align:top;text-align:right">V.</td>
                            <td style="padding-left:5px;">Pemegang Desain Industri</td>
                        </tr>
                        <tr>
                            <td style="padding-left:5px;">Nama</td>
                            <td>:</td>
                            <td style="padding-left:10px;">{{ fpdata.OWNER.NAME }}</td>
                        </tr>
                        <tr>
                            <td style="padding-left:5px;">Alamat</td>
                            <td>:</td>
                            <td style="padding-left:10px;">{{ fpdata.OWNER.ADDR }}</td>
                        </tr>
                        <tr>
                            <td style="padding-left:5px;">Kewarganegaraan</td>
                            <td>:</td>
                            <td style="padding-left:10px;">{{ fpdata.OWNER.NATION }}</td>
                        </tr>
                        <tr>
                            <td style="text-align:right"> VI.</td>
                            <td style="padding-left:5px;">Jenis Desain Industri</td>
                            <td>:</td>
                            <td style="padding-left:10px;">{{ fpdata.APPL_SUBTYPE_NAME }}</td>
                        </tr>
                        <tr>
                            <td style="text-align:right">VII.</td>
                            <td style="padding-left:5px;">Judul Desain Industri</td>
                            <td>:</td>
                            <td style="padding-left:10px;">{{ fpdata.TITLE }}</td>
                        </tr>
                        <tr>
                            <td style="text-align:right">VIII.</td>
                            <td style="padding-left:5px;">Tanggal Kadaluarsa</td>
                            <td>:</td>
                            <td style="padding-left:10px;">
                                {{ fpdata.TGLKADALUARSA }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4" style="padding:20px 0 0 0;">
                                Adalah benar dan tercatat dalam database kami.
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                Untuk memastikan bahwa Anda mengakses Database yang benar, pastikan bahwa URL pada browser Anda adalah <a :href="fpdata.FPURL">{{ fpdata.FPURL }}</a>
                            </td>
                        </tr>
                    </table>
            </div>
        </div>
        </template>
        <template v-else>
            <div style="width:100%;height:100%;">
                <img src="../../../public/img/dna-image.png" style=" position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);"/>
            </div>
        </template>
    </div>
</template>

<script>
import api from './api';

export default{
    data(){
        return {
            fpdata : {}
        }
    },
    methods: {
        async loadData(data){
            var res = await api.getQRFrontPage(data);
            if (res.data.length > 0){
                this.fpdata = res.data[0];
                let inventors = this.fpdata.INVENTORS.split("#DELIMITERINV#");
                let arrinvent = [];
                for (let i=0; i<inventors.length; i++){
                    let pinvent = inventors[i].split("#DELIMITERPERSON#");
                    arrinvent.push({NAME:pinvent[0], ADDR:pinvent[1], NATION:pinvent[2]});
                }
                this.fpdata['INVENTORS'] = arrinvent;
                let owner = this.fpdata.OWNER.split("#DELIMITERPERSON#");
                this.fpdata['OWNER'] = {NAME:owner[0], ADDR:owner[1], NATION:owner[2]};

            }else
                this.fpdata = res.data;
        }
    },
    async mounted(){
      await this.loadData(this.$route.params.code);
    },
}
</script>


<style>
    body {
        background-color:#EDEEE1;
        color:black;
    }

    a{
        color: red;
    }
</style>
